import fetcher from '@/services/fetcher'
import type { Rank } from '@/types'
import { toApiUrl } from '@/utils/url-generation-utils'
import { defineStore } from 'pinia'

type UserProgressionState = {
  fetchPromise: Promise<Array<Rank>> | null
  ranks: Array<Rank>
}

export const useUserProgressionStore = defineStore('user-progression', {
  state: (): UserProgressionState => ({
    fetchPromise: null,
    ranks: [],
  }),

  actions: {
    async fetchRanks(): Promise<Array<Rank>> {
      // return the fetch winners promise to prevent multiple calls
      if (this.fetchPromise) {
        return this.fetchPromise
      }

      if (this.ranks.length) {
        return this.ranks
      }

      try {
        this.fetchPromise = fetcher
          .get<Array<Rank>>(toApiUrl('/xp/ranks'))
          .then(async (response) => {
            this.ranks = response.data.value ?? []

            return this.ranks
          })
      } catch (error: any) {
        // TODO: Add Datadog custom log
      }

      return this.fetchPromise ?? this.ranks
    },
  },
})
